import { render, staticRenderFns } from "./tableK.vue?vue&type=template&id=4a1036cb&scoped=true&"
import script from "./tableK.vue?vue&type=script&lang=js&"
export * from "./tableK.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1036cb",
  null
  
)

export default component.exports